<template>
  <div class="animated fadeIn">
    <GeneralSpinner v-if="!generator_shunt && !pump_shunt && !diffs_shunt"></GeneralSpinner>
    <div class="tabs-select-style col-md-12 mb-12">
      <ul class="nav nav-pills nav-fill">
        <li class="nav-item" v-if="generator_shunt">
          <a class="nav-link" v-bind:class="{ active: tab_selected_generator }" @click="clickNavTabs('generator')">
            {{web_texts.generator}}
          </a>
        </li>
        <li class="nav-item" v-if="pump_shunt">
          <a class="nav-link" v-bind:class="{ active: tab_selected_pump }" @click="clickNavTabs('pump')">
            {{web_texts.pump}}
          </a>
        </li>
        <li class="nav-item" v-if="diffs_shunt">
          <a class="nav-link" v-bind:class="{ active: tab_selected_diffs }" @click="clickNavTabs('diffs')">
            {{web_texts.diffs}}
          </a>
        </li>
      </ul>
    </div>
    <br>
    <div class="col-md-12 mb-12">
      <div v-if="tab_selected_generator">
        <GeneratorShunting :devices="devices"></GeneratorShunting>
      </div>
      <div v-else-if="tab_selected_pump">
        <PumpShunting :devices="devices"></PumpShunting>
      </div>
      <div v-else-if="tab_selected_diffs">
        <DiffShunting></DiffShunting>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Shuntting';
  import trans_es from '../translates/es/Shuntting';
  import constants from '../constants';
  import middleware from '../utilities/middlewares';
  import GeneratorShunting from './partials/shuntting_partials/GeneratorShunting.vue';
  import PumpShunting from './partials/shuntting_partials/PumpShunting.vue';
  import DiffShunting from './partials/shuntting_partials/DiffShunting.vue';
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: 'Shunting',
    data() {
      return {
        web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
        system: '',
        devices: '',
        generator_shunt: false,
        pump_shunt: false,
        diffs_shunt: false,
        tab_selected_generator: false,
        tab_selected_pump: false,
        tab_selected_diffs: false
      }
    },
    components: {
      GeneratorShunting,
      PumpShunting,
      DiffShunting,
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      this.system = JSON.parse(window.localStorage.getItem('system'));

      this.haveGenerator()
    },
    methods: {
      // Opcions dels v-if amb la seleccio del TAB
      clickNavTabs(tab) {
        switch (tab) {
          case 'generator':
            this.tab_selected_generator = true;
            this.tab_selected_pump = false;
            this.tab_selected_diffs = false;
            break;
          case 'pump':
            this.tab_selected_pump = true;
            this.tab_selected_generator = false;
            this.tab_selected_diffs = false;
            break;
          case 'diffs':
            this.tab_selected_diffs = true;
            this.tab_selected_pump = false;
            this.tab_selected_generator = false;
            break;
          default:
            console.log('Option not registered');
            break;
        }
      },
      // Mirar si algun dispositiu te un generador
      haveGenerator() {
        axios.post(constants.ROOT_URL + '/api/v1/get_devices', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.devices = response.data;
          var devices_local = response.data;
          for (var i = 0; i < devices_local.length; i++) {
            if (devices_local[i].name.indexOf("Grup") > 0) {
              this.generator_shunt = true;
              this.tab_selected_generator = true;
            }
          }
          this.getMastersBySystem();
        }, (response) => {
          this.getMastersBySystem();
          console.log(response);
        });
      },
      // Llegir els masters amb les seves bombes
      getMastersBySystem() {
        axios.post(constants.ROOT_URL + '/api/v1/get_masters', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          window.localStorage.setItem('masters', JSON.stringify(response.data));
          this.havePump(response.data[0].id)
        }, (response) => {
          console.log(response)
        });
      },
      // Llegir les bombes dels masters
      havePump(master_id) {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + master_id + '", "R$EVE_E_Bomba_ON.ST", "R$EVE_E_Bomba_OFF.ST", "R$EVE_Selector_ON.ST", "R$EVE_Selector_OFF.ST", "R$EVE_Selector_AUT.ST" ,"R$EVE_APP_Bomba_Poweroff_AUT.ST"]]'
        }).then((response) => {
          this.pump_shunt = true;
          if (!this.tab_selected_generator) {
            this.tab_selected_pump = true;
          }
          this.haveMagnets(master_id);
        }, (response) => {
          this.haveMagnets(master_id);
          console.log(response)
        });
      },
      // Llegir les bombes dels magnetos
      haveMagnets(master_id) {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + master_id + '", "R$EVE_E_MagnetoDif_Pou_ON.ST", "R$EVE_E_MagnetoDif_Bassa_ON.ST"]]'
        }).then((response) => {
          this.diffs_shunt = true;
          if (!this.tab_selected_generator && !this.tab_selected_pump) {
            this.tab_selected_diffs = true;
          }
        }, (response) => {
          console.log(response)
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Shuntting.vue?2311e01a